import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { moduleName } from '../../constants';
import { URI } from '../../constants/URI';
import { setCustomer } from '../slices/filtersSlice';
import { appendOrderItems, removeOrderItemById, setOrderItems } from '../slices/orderSlice';
import { appendOpenOrderItems, appendOpenOrderItemToProducts, removeOpenOrderItemById } from '../slices/productsSlice';
import { store } from '../store';

export const addOrder = async (body) => {
    const res = await handlePostRequest(URI.order, body, {
        module: moduleName.ORDER,
    });
    return res;
};

export const updateOrder = async (body, { isGet = true } = {}) => {
    const res = await handlePutRequest(URI.order, body, {
        module: moduleName.ORDER,
        toast: false,
    });
    if (res?.ack && isGet) {
        getOrdersById(body.id);
    }
    return res;
};

export const addOrderItem = async (body, product, isAppend = true) => {
    const res = await handlePostRequest(URI.order_item, body, {
        module: moduleName.ORDER_ITEM,
        loading: false,
    });
    if (res?.ack) {
        const order = {
            ...product,
            id: res.record_id,
            product_netsuite_id: product?.netsuite_id ?? product?.product_netsuite_id,
            product_name: product?.name,
            product_code: product?.code,
            vat: product?.taxable?.toLowerCase() === 'taxable' ? 20 : 0,
            quantity: body?.quantity ?? 1,
        };
        if (isAppend) {
            store.dispatch(appendOrderItems(order));
            store.dispatch(appendOpenOrderItems(order));
        }
    }

    return res;
};

export const getOrders = async (body) => {
    const res = await handlePostRequest(URI.orders, body, {
        module: moduleName.ORDER,
    });
    return res;
};

export const deleteOrder = async (orderId) => {
    const res = await handleDeleteRequest(
        URI.order,
        { id: orderId },
        {
            module: moduleName.ORDER,
        }
    );
    return res;
};

export const getOrdersById = async (orderId) => {
    const res = await handleGetRequest(URI.order, null, {
        module: moduleName.ORDER,
        params: {
            id: orderId,
        },
    });
    store.dispatch(setOrderItems(res?.order_details || []));
    store.dispatch(appendOpenOrderItems(res?.order_details || []));
    store.dispatch(setCustomer(res?.order?.customer_netsuite_id || null));
    return res;
};

export const removeOrderItem = async (orderItemId, orderId, product = null) => {
    const res = await handleDeleteRequest(
        URI.order_item,
        { id: orderItemId },
        {
            module: moduleName.ORDER_ITEM,
            loading: false,
        }
    );
    if (res?.ack) {
        if (product) {
            store.dispatch(appendOpenOrderItemToProducts(product));
        }
        store.dispatch(removeOrderItemById(orderItemId));
        store.dispatch(removeOpenOrderItemById(orderItemId));
        getOrdersById(orderId);
    }
    return res;
};

export const postOrderToNetSuite = async (body) => {
    const res = await handlePostRequest(URI.post_orders, body, {
        module: moduleName.POST_ORDER,
    });
    return res;
};

export const getInvoices = async (body, config = {}) => {
    const res = await handlePostRequest(URI.invoices, body, {
        module: moduleName.GET_INVOICES,
        ...config,
    });
    return res;
};

export const getOpenOrderByCustomer = async (customerNetsuiteId) => {
    const res = await handleGetRequest(URI.open_order, null, {
        toast: false,
        params: {
            customer_netsuite_id: customerNetsuiteId,
        },
    });
    return res;
};

export const updateTierPrice = async (body) => {
    const res = await handlePutRequest(URI.item_price, body, {
        loading: false,
        toast: false,
    });
    return res;
}

export const getOrderLink = async (orderId) => {
    const res = await handleGetRequest(URI.ns_link, null, {
        toast: false,
        params: {
            internal_id: orderId,
        },
    });
    return res;
}

export const addInvoiceNote = async (body) => {
    const res = await handlePostRequest(URI.invoice_note, body);
    return res;
}

export const updateNetSuiteOrder = async (body) => {
    const res = await handlePutRequest(URI.existing_ns_order, body, {});
    return res;
}

export const getExistingOrders = async (params) => {
    const res = await handleGetRequest(URI.existing_orders, null, {
        toast: false,
        params
    })

    return res
}

export const getIntentUrl = async (body) => {
    const res = await handleGetRequest(URI.intent_url, null, {
        toast: false,
        params: body,
    });
    if (res?.success) {
        return res?.url;
    }
    return null;
}

export const createPaymentIntent = async (body) => {
    const res = await handlePostRequest(URI.create_payment, body, {
        toast: false,
        loading: false,
    });
    return res;
};

export const checkPaymentStatus = async (body) => {
    const res = await handlePostRequest(URI.check_payment_status, body, {
        toast: false,
        loading: false,
    });
    return res;
};